import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { Logo } from './Logo';
import { FOOTER_COLUMNS } from '../../siteNav';
import { useQuoteModal } from '../../contexts/QuoteModalContext';
import { IG_WEB, openInstagram } from '../../lib/instagram';

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export default function Footer() {
  const { openModal } = useQuoteModal();
  return (
    <footer id="contact" className="relative bg-black border-t border-white/10" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 py-20">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10 py-12 border-b border-white/10">
          <div className="col-span-2">
            <Logo />
            <p className="text-[#cfc8bb] text-sm mt-6 max-w-sm leading-relaxed">
              Merch production and manufacturing for artists, brands and clothing labels — with live event
              printing as a separate service.
            </p>
            <ul className="flex flex-col gap-1.5 text-[#cfc8bb] text-sm mt-6">
              <li>hello@pushateez.com</li>
              <li>+1 (310) 853-0733</li>
              <li data-testid="footer-service-area">Production in Los Angeles &amp; Orange County</li>
              <li data-testid="footer-live-events-area">Live events in LA, San Francisco &amp; San Diego</li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a
                href={IG_WEB}
                onClick={openInstagram}
                data-testid="footer-instagram-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pusha Teez on Instagram"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-[#f4efe6] hover:bg-[#00b8ff] hover:text-black hover:border-[#00b8ff] transition-colors duration-200"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <button
                type="button"
                onClick={openModal}
                className="rounded-full bg-[#00b8ff] text-black px-5 py-2.5 text-sm font-semibold hover:bg-[#f4efe6] transition-colors duration-200"
                data-testid="footer-production-quote-btn"
              >
                Get a Production Quote
              </button>
            </div>
          </div>
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title} data-testid={`footer-col-${slug(col.title)}`}>
              <p className="text-xs uppercase tracking-[0.2em] text-[#00b8ff] mb-4">{col.title}</p>
              <ul className="flex flex-col gap-2.5 text-[#f4efe6] text-sm">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="hover:text-[#00b8ff] transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 text-xs text-[#9b958a]">
          <p>© {new Date().getFullYear()} Pusha Teez. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
